<script>
//FacetCollapse.vue
import TransitionCollapseHeight from "./../TransitionCollapseHeight"

export default {
    components: {
        TransitionCollapseHeight
    },
    props: {
        title: String,
    },
    data() {
        return {
            expanded: false
        }
    },
    methods:
        {
            groupOpen() {
                this.expanded = true;
            },
            toggleCardState() {
                this.expanded = !this.expanded;
            },

            closeAll() {
                this.expanded = false;
            },
            expandAll() {
                this.expanded = true;
            },
        },
    created() {
        scoopOS.$on("closeAllFacetGroups", this.closeAll);
        scoopOS.$on("expandAllFacetGroups", this.expandAll);
    }
}
</script>

<template>
    <div>
        <div class="clearb">
            <div class="ccard" :class="{ 'not-expanded': !this.expanded }">
                <header class="ccard-header" @click="toggleCardState">
                    <p class="ccard-header-title">
                        <i class="fa fa-filter" aria-hidden="true"></i> {{ title }}
                        <a class="ccard-header-icon">
                    <span class="icon">
                      <i class="fa fa-angle-up"></i>
                    </span>
                        </a>
                    </p>
                </header>
                <div class="ccard-content">
                    <TransitionCollapseHeight>
                        <div v-show="expanded" class="ccontent">
                            <slot></slot>
                        </div>
                    </TransitionCollapseHeight>
                </div>

            </div>
        </div>
    </div>
</template>

<style>
.clearb {
    clear-after: both;
}

.ccard {
    margin-top: 10px;
    margin-bottom: 10px;
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
}

.ccard .ccard-header {
    border-bottom: 1px solid #a39577;
    margin-bottom: 8px;
    cursor: pointer;
    color: #7a797b;
    font-weight: 600;
    font-size: 14px;
    font-style: italic;
    text-transform: none;
    font-smooth: always;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
}

.ccard .ccard-header .icon {
    transform: rotate(180deg);
    transition: transform 150ms ease-out;
    float: right !important;
    color: #7a797b;
}

/*.ccard .ccard-content {*/
/*    -webkit-transition: max-height .2s linear;*/
/*    -moz-transition: max-height .2s linear;*/
/*    -ms-transition: max-height .2s linear;*/
/*    -o-transition: max-height .2s linear;*/
/*    transition: max-height .2s linear;*/
/*    overflow: auto;*/
/*    max-height: 100vh;*/
/*}*/

.ccard.not-expanded .ccard-header .icon {
    transform: rotate(0deg);

}

/*.ccard.not-expanded .ccard-content {*/
/*    transform: scaleY(0);*/
/*    transform-origin: top;*/
/*    opacity: 0;*/
/*    max-height: 0;*/
/*    padding: 0;*/
/*    margin: 0;*/
/*}*/

</style>
